import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-custom-divider',
    templateUrl: './custom-divider.component.html',
    styleUrls: ['./custom-divider.component.scss'],
    standalone: false
})
export class CustomDividerComponent {

}
